import { Item } from "./Item";

export class AppInfoItem extends Item {
    public updateInfo(data: Map<any, any>) {
    }
}
